import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';

import { Container, PageInformation,AlterPage } from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PDFprops {
  url: any;
}

interface LoadProps {
  numPages: number;
}

interface Action {
  type: 'increment' | 'decrement';
}

const PDFViewer: React.FC<PDFprops> = ({ url }) => {
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);

  

  function onDocumentLoadSuccess({ numPages }: LoadProps) {
    setNumPages(numPages);
  }

  function onPageChange(value: number) {
    setPageNumber(value);
  }

  function handleClick({ type }: Action) {
    switch (type) {
      case 'increment':
        return onPageChange(pageNumber + 1);
      case 'decrement':
        return onPageChange(pageNumber - 1);
      default:
        return onPageChange(pageNumber);
    }
  }

  return (
    <Container>
      <Document
        file={`data:application/pdf;base64,${url}`}
        onLoadSuccess={onDocumentLoadSuccess}
        options={{
          cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
          cMapPacked: true,
        }}
      >
        <Page pageNumber={pageNumber} />
      </Document>
      <PageInformation>
        <AlterPage>
          <Button
            variant="light"
            disabled={pageNumber === 1}
            onClick={() => handleClick({ type: 'decrement' })}
          >
            <FiArrowLeft />
          </Button>
          <p>{`Página ${pageNumber} de ${numPages}`}</p>
          <Button
            variant="light"
            disabled={pageNumber === numPages}
            onClick={() => handleClick({ type: 'increment' })}
          >
            <FiArrowRight />
          </Button>
        </AlterPage>
      </PageInformation>
    </Container>
  );
};

export default PDFViewer;
